export const regexes = {
    // url:/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
    // strContainNumber:/.*[0-9].*/,
    // strCapitalize:/.*[A-Z].*/,
    // strSpecial:/.*[!@#$%^&*()_+].*/,
    // password:/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d$@$!%* #+=\(\)\^?&]{6,}$/,
    password: /^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)[0-9a-zA-Z]{6,}$/,
    //email:/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/,
    // email:/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    //https://emailregex.com/
    email: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
    url: /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/

}

// At least one English letter, (?=.*?[A-Za-z])

// At least one digit, (?=.*\d)

// At least one special character, (?=.[$@$!% #+=()\^?&]) Add more if you like...

// Minimum length of 6 characters (?=.[$@$!% #?&])[A-Za-z\d$@$!%* #+=()\^?&]{6,} include spaces
export const checkPassword = function(password){
    // return !!password.match(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d$@$!%* #+=\(\)\^?&]{6,}$/);
    return !!password.match(/^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)[0-9a-zA-Z]{6,}$/);
}
export const passwordStrength = (str, options) =>  {
    let return_ = {
        strength:3,
        success:false,
        error:''
    }
    let ops = {
        length:10,
        numeric:true,
        capitalize:true,
        special:false,
    };
    if (options) {
        ops = options
    }
    let prop;
    let x = 0;
    for (prop in ops) {
        if (!!ops[prop]) {
            x++;
        }
    }
    
    return_.strength = x;
    if (ops.length && str.length < ops.length) {
        return_.success = false;

        return_.error = 'length';

        return return_;
    } else {
        return_.strength = return_.strength === 0 ? return_.strength : return_.strength - 1;
        return_.success = true;
    }
    if (ops.numeric) {
        if (!!str.match(regexes.strContainNumber)) {
            return_.strength = return_.strength === 0 ? return_.strength : return_.strength - 1;
            return_.success = true;
        } else {
            return_.success = false;

            return_.error = 'number';
   
            return return_;
        }

    }
    if (ops.capitalize) {
        if (!!str.match(regexes.strCapitalize)) {
            return_.strength = return_.strength === 0 ? return_.strength : return_.strength - 1;
            return_.success = true;
        } else {
            return_.success = false;
            return_.error = 'capitalize';

            return return_;
        }

    }
    if (ops.special) {
        if (!!str.match(regexes.strSpecial)) {
            return_.strength = return_.strength === 0 ? return_.strength : return_.strength - 1;
            return_.success = true;
        } else {
            return_.success = false;
            return_.error = 'special';

            return return_;
        }

    }



    return return_;
}



// WEBPACK FOOTER //
// ./src/functions/regexes.js